import React from 'react';

interface ComingSoonProps {
  message?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({
  message = 'Administration and configuration features (roles, integrations, branding) will appear in this area.',
}) => (
  <div className="coming-soon">
    <span className="soon-badge">Coming soon</span>
    <p>{message}</p>
  </div>
);

export default ComingSoon;
